<template>
    <div>
        <hts-form-select
            ref="select"
            v-model="cValue"
            :items="selectItems"
            :label="$t('labels.roles')"
            key-id="key"
            key-label="label"
            :prop="prop"
            :name="name"
            multiple
            :filterable="true"
            :clearable="true"
            :creatable="creatable"
            :disabled="disabled"
            :param-prepare="selectItems"
            @change="handleChange" />
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => ''
  },
  text: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  creatable: {
    type: Boolean,
    default: false
  },
  prop: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  itemName: {
    type: String,
    default: ''
  }
})

const select = ref()
const emits = defineEmits(['update:modelValue', 'click', 'change'])

const { modelValue } = toRefs(props)

const selectItems = ref([
  {
    label: 'Điều độ',
    key: 'distribution'
  },
  {
    label: 'Kinh doanh',
    key: 'business'
  },
  {
    label: 'Tài xế',
    key: 'driver'
  },
  {
    label: 'Pricing',
    key: 'pricing'
  },
  {
    label: 'Chăm sóc khách hàng',
    key: 'customerCare'
  },
  {
    label: 'Khác',
    key: 'other'
  }
])

const cValue = computed({
  get () {
    if (!Array.isArray(modelValue.value)) {
      return [modelValue.value]
    }
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const handleChange = (val: any) => {
  emits('change', val)
}
</script>
